import { useField } from "formik"
import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { DynamicConfigKey } from "../../form/formTypes"
import { CreateBillDialogMS } from "./CreateBillDialogMS"
import { BillReceiversItemMS } from "../../../createOrderTypes"
import { billReceiverToApi } from "../../../../billReceivers/billReceiverToApi"
import { createBillReceivers } from "../../../../billReceivers/billReceiverApi"

type CreateBillReceiverProps = Readonly<{
    userId: number
    handleCloseDialog: () => void
}>

export const CreateBillReceiver = ({ userId, handleCloseDialog }: CreateBillReceiverProps) => {
    const { l10n } = useAppLocalization()
    const [_field, _meta, helpers] = useField(DynamicConfigKey.BUYER_PARTIES)

    const { mutateAsync: doCreateBillReceiver } = useApiMutation(createBillReceivers, {
        async onSuccess(_, data) {
            helpers.setValue(data.billReceiver)
        },
    })

    const onSimpleReceiverSelect = (billReceiver: BillReceiversItemMS) => {
        helpers.setValue(billReceiver)
    }

    return (
        <CreateBillDialogMS
            userId={userId}
            onSelectBillReceiver={async (formValues) => {
                const endpointType = formValues.companySendInvoice
                const endpointValue = formValues.search
                const billType = formValues.type

                const apiRequestBody = billReceiverToApi(formValues, billType, endpointValue, endpointType, userId)

                await doCreateBillReceiver({ billReceiver: apiRequestBody?.billReceiver })
                handleCloseDialog()
            }}
            onSimpleSelect={onSimpleReceiverSelect}
            open
            onClose={handleCloseDialog}
            title={l10n.getString("bill-receivers-create-dialog-title")}
        />
    )
}
